import ViewMedicationItemTemplate from "app/features/residents/templates/view/ViewMedicationItemTemplate";

interface Props {
  isDiscontinued?: boolean;
}

export default function MedicationItemScreen({ isDiscontinued }: Props) {
  return <ViewMedicationItemTemplate isDiscontinued={isDiscontinued} />;
}
